import React, { useEffect, useState } from "react";
import Helmet from "next/head";

const BazaarVoiceMetaTags = () => {
    const [bvDidInit, setBvDidInit] = useState(false);
    const [content, setContent] = useState(null);

    const initBVOnEvent = (event) => {
        initBV();
        event.currentTarget.removeEventListener(event.type, initBVOnEvent);
    };
    const initBV = () => {
        if (bvDidInit) {
            setContent(null);
            return false;
        }
        const markup = (
            <Helmet>
                {
                    process.env.SITE_ENV === "Prod" ? (
                        <script
                            async
                            src="https://apps.bazaarvoice.com/deployments/PanteneBrazil/main_site/production/pt_BR/bv.js"
                        ></script>
                    ) : (
                        <script
                            async
                            src="https://apps.bazaarvoice.com/deployments/PanteneBrazil/main_site/staging/pt_BR/bv.js"
                        ></script>
                    )
                }
            </Helmet>
        );
        setContent(markup);
        setBvDidInit(true);
    };
    useEffect(() => {
        document.addEventListener("DOMContentLoaded", () => {
            var timer = 3.5;
            setTimeout(initBV, timer * 1000);
        });
        document.addEventListener("scroll", initBVOnEvent);
        document.addEventListener("mousemove", initBVOnEvent);
        document.addEventListener("touchstart", initBVOnEvent);

        return () => {
            document.removeEventListener("scroll", initBVOnEvent);
            document.removeEventListener("mousemove", initBVOnEvent);
            document.removeEventListener("touchstart", initBVOnEvent);
        };
    }, []);

    return content;
};

export default BazaarVoiceMetaTags;